<template>
    <div class="enterprisewebsite" v-title data-title="报告详情" data="newsdetail">
        <leftnav class="fl"></leftnav>
        <div class="index_left" :style="isCollapse ? 'margin-left: 0;width:100%' : ''">
            <govheader></govheader>
            <el-dialog class="localChain" title="" :visible.sync="isShowFreeUserTips" width="650px" top="20vh">
				<freeUserTips :type="4" :bgtype="0"></freeUserTips>
			</el-dialog>
            <div class="index_left_centerpage flexcss">
                <div class="whitebox widthPC-100">
                    <div class="widthPC-95 margin-x-auto">
                        <div class="detail_report_li">
                        <div class="img-box"><img :src="pageData.image" /></div>
                        <div class="fl">
                            <h4 class="title">{{ pageData.title }}</h4>
                            <p class="indu_date smfont">所属行业：{{ pageData.industry1Text }} <i>></i> {{ pageData.industry2Text }}</p>
                            <p class="indu_date smfont"><span>首次出版： {{pageData.publishDate}}</span> &nbsp; &nbsp; &nbsp; &nbsp; <span>最新修订：{{ pageData.reviseDate }}</span> </p>
                            <p class="indu_date smfont">报告属性：共{{ pageData.wordCount }} 万字、{{ pageData.chartCount }} 个图表</p>
                            <a :href="pageData.url" target="_blank" class="curp indu_date smfont">单独购买此报告 ></a>
                        </div>
                        <div class="fr mr-3 mt-8"><span class="read-btn title-read" @click="openFreePop()"><i class="el-icon-notebook-2 mr-1"></i>开始阅读</span></div>
                    </div>
                    <div class="copyrightNotice ">
                        <h3 class="title ml-3">版权声明</h3>
                        <p>我公司在线研究报告受《中华人民共和国著作权法》等相关法律保护，用户仅限公司或单位内部阅读使用。不得进行恶意复制、转载、截屏和解密，不得使用程序对报告内容进行抓取或破解，系统检测到相关行为后自动终止使用权限；用户也不得以任何形式向第三方扩散和传播，否则须承担相应的法律责任。</p>
                        <p class="my-3">特此声明！</p>
                        <p class="text-right">中投产业研究院</p>
                    </div>
                    <div class="detail_summary px-5">
                        <h3 class="title">引言</h3>
                        <div class="content" v-html="pageData.summary"></div>
                    </div>
                    <div class="detail_summary px-5">
                        <h3 class="title">目录</h3>
                        <div class="catalog">
                            <ul>
                                <li v-for="(item,i) in pageData.catalog" :key="i">{{ item.t }}</li>
                            </ul>
                        </div>
                    </div>
                    <div class="detail_summary px-5">
                        <h3 class="title">图表目录</h3>
                        <div class="catalog" v-html="pageData.chart"></div>
                    </div>
                    
                    <div class="text-center mb-6" @click="openFreePop()"><span class="read-btn">开始阅读</span></div>
                    </div>
                </div>
            </div>

        </div>

        <!-- <footerbar v-if="userdata.userType>1"></footerbar> -->
    </div>
</template>

<script>
import freeUserTips from "@/components/enterpriseInc/free-user-tips.vue"
import { mapState, mapMutations, mapGetters } from "vuex";

export default {
    name: 'newsdetail',
    computed: {
        ...mapState({
            isCollapse: (state) => state.isCollapse,
        }),
        ...mapGetters(['isCollapse'])
    },
    data() {
        return {
            userdata: {},
            id: {},
            pageData:{},
            isShowFreeUserTips:false,
            catalogList:[],
        }
    },
    components: {
        freeUserTips
    },
    created() {
        this.$nextTick(() => {
            // 禁用右键
            document.oncontextmenu = new Function("event.returnValue=false");
            // 禁用选择
            document.onselectstart = new Function("event.returnValue=false");
        });
        // this.userdata = this.getuseriformation();
        this.id = this.$route.query.id * 1;
        this.getPageData();
    },
    mounted() {
    },
    methods: {
        openFreePop(){
            this.isShowFreeUserTips = true;
        },
        getPageData() {
			var _this = this;
			var ajaxurl = this.$api.cyl.report.detail()+'?id='+this.id;
			this.$axios.get(ajaxurl).then(function (res) {
				if (res.data.success) {
					console.log('报告详情', res);
                    _this.pageData = res.data.data;
                    document.title = _this.pageData.title+'产业研究大脑体验版';
                    let newText = _this.pageData.summary.replace(/<br \/>/g, '<br/>').replace(/<p>/, '<p style="text-indent: 2em;"');
                    _this.pageData.summary = newText;
                    _this.pageData.catalog =  JSON.parse(_this.pageData.catalog); //后台穿回来的是string 要转成 object
				} else {

				}
			}).catch(function (error) {
				// 请求失败处理 console.log(error);
			});
		},
    }
}



</script>

<style scoped="scoped" lang="scss">
.catalog{
    width: 600px;
    // border: 1px solid red;
    margin: 0 auto;
    line-height: 30px;
}
.leftconbox {
    min-height: 840px;
}
.detail_report_li{
    width: 95%;
    height: auto;
    padding: 20px 10px;
    margin: 20px;
    border-bottom: 1px solid #eee;
    &::after{
        content: "";
        display: block;
        clear: both;

    }
    .img-box {
		width: 154px;
		height: auto;
		float: left;
		margin-right: 30px;
		img {
			width: 100%;
			height: 100%;
		}
	}

	.title {
		padding-top: 20px;
		height: 48px;
		line-height: 24px;
		text-overflow: ellipsis;
		overflow: hidden;
		font-size: 24px;
		padding-bottom: 5px;
	}

	.smfont {
		color: #707070;
		font-size: 18px;
        line-height: 40px;
	}
}
.copyrightNotice{
    border-bottom: 1px solid #eee;
    .title{
        font-size: 24px;
        padding: 50px 0 36px;
    }
    p{
        font-size: 18px;
        text-indent: 2em;
        line-height: 50px;
        letter-spacing: 1px;
    }
}
.detail_summary{
    margin-bottom: 60px;
    .title{
        font-size: 28px;
        padding: 40px 0;
        text-align: center;
    }
    .content { 
        line-height: 42px;
        margin-bottom: 36px;
        font-size: 18px;
        text-indent: 2em;

        p{
            text-indent: 2em;
        }
    }
    p{
        margin-bottom: 30px;
    }
}
.read-btn{
    display: inline-block;
    width: 174px;
    height: 38px;
    line-height: 38px;
    background: #edf1fa;
    text-align: center;
    // margin-bottom: 60px;
    cursor: pointer;
    border-radius: 4px;
    transition: all .3s;
    &:hover{
        background: #5E83CC;
        color: #fff;
    }
}
.title-read{
    background: #0069D3;
    color: #fff;
}
</style>
